import classNames from 'classnames';
import { toLower } from 'lodash';
import { useTranslation } from 'react-i18next';

import { SelfMatchAction } from 'components/types';

import { SelfMatchAction as SelfMatchActionEnum } from 'components/enums';
import Chip from '@sdb/ui/atoms/Chip';

const defaultMatchActions = [
  SelfMatchActionEnum.NONE,
  SelfMatchActionEnum.SUBSCRIBE,
  SelfMatchActionEnum.CONNECT
] as const;

type Props = {
  value: SelfMatchAction | null;
  matchActions?: SelfMatchAction[];
  onClick: (action: SelfMatchAction) => void;
  disabled?: boolean;
  disabledSubscribe?: boolean;
};

export default function MatchActionSelector({
  value,
  matchActions,
  onClick,
  disabled,
  disabledSubscribe
}: Props) {
  const { t } = useTranslation('common');

  return (
    <>
      {(matchActions || defaultMatchActions).map((action) => (
        <td key={action}>
          <Chip
            shape="pill"
            disabled={
              disabled ||
              (action == SelfMatchActionEnum.SUBSCRIBE && disabledSubscribe)
            }
            label={t(toLower(action))}
            variant={value === action ? 'filled' : 'outlined'}
            className={classNames('chip', { selected: value === action })}
            onClick={() => onClick(action)}
          />
        </td>
      ))}
    </>
  );
}
